/* eslint-disable max-len */
import { ICoinPageData } from 'pages/loans/[coin]/assets/page-data/types'

import ltcQuestions from 'images/coin-pages/questions/ltc.svg'

import { commonSlidesData } from '../commonPageData'

export const ltcPage: ICoinPageData = {
  title: 'coin_636',
  description: 'coin_637',
  // description: 'coin_638',
  h1: (t, _, replacePlaceholders) => (
    <span dangerouslySetInnerHTML={{ __html: replacePlaceholders(t('get_instant_coin_loan'), { coin: 'Litecoin' }) }} />
  ),
  questionsBlock: {
    image: ltcQuestions,
    questions: [
      {
        title: 'coin_639',
        answer: 'coin_640',
      },
      {
        title: 'coin_641',
        answer: 'coin_642' +
          '- The Litecoin blockchain is the largest global scrypt based network;<br>' +
          '- Litecoin is one of the biggest cryptocurrencies by market cap.<br>',
      },
      {
        title: 'coin_643',
        answer: 'coin_644',
      },
      {
        title: 'coin_645',
        answer: 'coin_646',
      },
    ],
  },
  whatIs: {
    ...commonSlidesData('Litecoin (LTC)'),
    text: [],
    blogCards: [
      {
        link: 'https://coinrabbit.io/blog/how-to-profit-during-the-2022-bull-season/',
        image:
          'https://sp-ao.shortpixel.ai/client/to_webp,q_lossless,ret_img,w_1185/https://coinrabbit.io/blog/wp-content/uploads/2022/02/integration-111CR_123123123.png',
        imageAlt: 'How to Profit During the 2022 Bull season?',
      },
      {
        link: 'https://coinrabbit.io/blog/how-to-earn-crypto-with-no-risks/',
        image:
          'https://sp-ao.shortpixel.ai/client/to_webp,q_lossless,ret_img,w_1185/https://coinrabbit.io/blog/wp-content/uploads/2021/11/integration-51CR_123123123.png',
        imageAlt: 'How to Earn Crypto with no Risks?',
      },
      {
        link: 'https://coinrabbit.io/blog/guide-to-short-selling-with-coinrabbit-bear-market-loans/',
        image: 'https://coinrabbit.io/blog/wp-content/uploads/2021/06/Bear-loans.png',
        imageAlt: 'Guide to short-selling with CoinRabbit bear market loans',
      },
    ],
    paragraphs: [
      {
        title: 'coin_647',
        text: ['coin_649'],
      },
      {
        title: 'coin_648',
        text: ['coin_650'],
      },
    ],
  },
}
